import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';
import {
  getConsentPolicyStateRefs,
  consentPolicyUiTypeMapper,
  consentPolicyPropsDeps,
  withConsentPolicyProps,
} from '@wix/thunderbolt-elements/src/components/ConsentPolicyWrapper/viewer/utils';
import type {
  GoogleMapDefinition,
  GoogleMapMapperProps,
  GoogleMapsPlatformProps,
  GoogleMapStateRefs,
} from '../GoogleMap.types';
import { consetPolicyKeys } from '../constants';
import { getSupportedLanguage } from '../utils';

export const props = withCompInfo<
  GoogleMapMapperProps,
  GoogleMapDefinition,
  GoogleMapsPlatformProps
>()(
  [
    'compId',
    'compData',
    'compProps',
    'translate',
    'language',
    'experiments',
    'editorName',
    ...consentPolicyPropsDeps,
  ],
  (compInfo, carmiData) => {
    const {
      compId,
      translate,
      language: siteLanguage,
      experiments,
      editorName,
    } = compInfo;

    const { urlQueries, mapData, skin } = carmiData;

    const language = getSupportedLanguage(siteLanguage);
    const wrappedUrlQueries = new URLSearchParams(urlQueries);
    wrappedUrlQueries.set('language', language);
    const isReactGoogleMap =
      experiments?.['specs.thunderbolt.reactGoogleMaps'] === true &&
      editorName === 'Studio';

    const originalProps = {
      id: compId,
      language,
      urlQueries: wrappedUrlQueries.toString(),
      mapData: {
        /** Create new instance of mapData to rerender iFrame on data changes
         * (useGoogleIFrame depends on immutability)
         */
        ...mapData,
        locations: mapData?.locations.map(location => ({
          ...location,
          directionTitle: translate('GoogleMaps', 'GoogleMaps_Directions_Link'),
        })),
      },
      skin,
      translations: {
        title:
          translate('component_label', 'COMPONENT_LABEL_googleMapsTitle') ||
          'Google Map',
        allyTargetBlankDescription:
          translate('GoogleMaps', 'googleMaps_ariaLabel_linkOpensNewTab') ||
          'Opens in a new tab',
      },
      isReactGoogleMap,
    };

    return withConsentPolicyProps(
      compInfo,
      originalProps,
      consetPolicyKeys.componentNameKey,
      consetPolicyKeys.componentNameDefault,
    );
  },
);

export const requiredStateRefs: Array<keyof GoogleMapStateRefs> = [
  'experiments',
  ...getConsentPolicyStateRefs(),
];

export const stateRefs =
  withStateRefsValues<keyof GoogleMapStateRefs>(requiredStateRefs);

export const uiType = consentPolicyUiTypeMapper;

export default createComponentMapperModel({
  props,
  stateRefs,
  uiType,
});
